angular.module('admin.index', [
  'common.header',
  'common.footer',
  'resources.User',
  'security.authorization',
  'services.adminResource'
])

.config(["$stateProvider", function($stateProvider) {
  $stateProvider
    .state('admin', {
      url: '/admin',
      title: 'Admin Area',
      views: {
        header: {
          template: require('../common/header/header.tpl.html'),
          controller: 'HeaderCtrl'
        },
        main: {
          template: require('./admin.tpl.html'),
          controller: 'AdminCtrl'
        },
        footer: {
          template: require('../common/footer/footer.tpl.html'),
          controller: 'FooterCtrl'
        }
      },
      resolve: {
        user: ["User", "$state", "$location", function(User, $state, $location) {

          return User.current(function (user) {
            if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
              return user;
            }
            if($location.path().indexOf("diagrams") > -1) {
              return user;
            }
            return $state.go('unauthorized');
          }).$promise;
        }],
        initSearch: ["searchService", "Article", function (searchService, Article) {
          searchService.setSearchFn(Article.search);
          searchService.setRedirectBase('/account/edit-article');
        }]
      }
    });
}])

.controller('AdminCtrl', ['$scope', '$log',
  function($scope, $log){
    // $scope.user = {
    //   users: stats['User'],
    //   accounts: stats['Account'],
    //   admins: stats['Admin'],
    //   groups: stats['AdminGroup']
    // };
    // $scope.pivoted = {
    //   categories: stats['Category'],
    //   statuses: stats['Status']
    // };
  }]);



// WEBPACK FOOTER //
// ./client/src/app/admin/admin.js